import axios, { AxiosInstance } from "axios";
import errorInterceptor from "./interceptors/error";
import updateHeaderInterceptor from "./interceptors/update-header";
import { resolveApiBaseUrl } from "../../config/api-config";

const apiBaseUrl = await resolveApiBaseUrl();

const httpClient: AxiosInstance = axios.create({
  baseURL: `${apiBaseUrl}/gaia-api/v1/`,
  withCredentials: true
});

errorInterceptor(httpClient);
await updateHeaderInterceptor(httpClient);

export default httpClient;
